import { useMemo } from 'react';

export const useSortedSpaces = <T>(
  items: T[],
  isDisabled: (item: T) => boolean,
): T[] =>
  useMemo(
    () =>
      [...items].sort((a, b) => Number(isDisabled(a)) - Number(isDisabled(b))),
    [items, isDisabled],
  );
